import React, { useState } from 'react';
import TagComponent from '../../components/atoms/Tag.Component';

const FAQItem = ({ question, answer, isOpen, onToggle }) => (
  <div className='border-b border-gray-300 py-5 cursor-pointer select-none' onClick={onToggle}>
    <div className='flex justify-between items-start gap-4'>
      <h3 className='text-lg font-semibold text-dark'>{question}</h3>
      <span className='text-2xl font-thin leading-none flex-shrink-0 text-gray-400'>
        {isOpen ? '−' : '+'}
      </span>
    </div>
    {isOpen && (
      <p className='mt-3 text-base font-light leading-relaxed text-gray-700'>
        {answer}
      </p>
    )}
  </div>
);

const FAQMobile = ({ lang, tags, title, items }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div className='w-full py-14 px-6'>
      <div className='overflow-hidden mb-8'>
        {tags[lang].map((tag, i) => <TagComponent key={i} value={tag} />)}
      </div>
      <div>
        {items.map((item, i) => (
          <FAQItem
            key={i}
            question={item.question[lang]}
            answer={item.answer[lang]}
            isOpen={openIndex === i}
            onToggle={() => toggle(i)}
          />
        ))}
      </div>
    </div>
  );
};

export default FAQMobile;
